
import ServicePageLayout from "@/components/ServicePageLayout";
import StyledBulletPoint from "@/components/StyledBulletPoint";
import { Button } from "@/components/ui/button";

const NettoyageLieux = () => {
  const openCalendly = () => {
    window.open("https://calendly.com/meneora/nettoyage-de-lieux", "_blank");
  };

  return (
    <ServicePageLayout
      heroImage="/lovable-uploads/f7889efd-b399-4fc7-81c3-9e5b3865d760.png"
      heroAlt="Nettoyage vibratoire d'espace à distance"
      heroTitle="Nettoyage énergétique de lieu – harmonisation à distance"
      heroText="Libérer les charges, élever la fréquence, sécuriser l'espace vibratoire."
    >
      {/* Pour qui section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-8">Pour qui ?</h2>
          
          <div className="bg-accent/10 p-6 rounded-lg mb-8">
            <p className="text-lg leading-relaxed text-center">
              Tu sens qu'il y a du "monde" dans ton lieu ?<br />
              Tu ressens une lourdeur, un sommeil parasité, des tensions que tu n'expliques pas ?<br />
              Tu ne te sens pas en paix chez toi, comme si l'espace était chargé ou fatigué ?<br />
              <span className="text-primary font-medium">Tu peux agir.</span>
            </p>
          </div>
          
          <div className="space-y-3 mt-8">
            <StyledBulletPoint>Ton lieu est perturbé, pesant, stagnant</StyledBulletPoint>
            <StyledBulletPoint>Tu sens une perte d'énergie dans ton cabinet</StyledBulletPoint>
            <StyledBulletPoint>Tu veux recharger ton espace de soin</StyledBulletPoint>
          </div>
        </div>
      </section>

      {/* Comment se déroule le nettoyage */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-8">Comment se déroule le nettoyage ?</h2>
          
          <div className="space-y-6 text-lg leading-relaxed">
            <p className="text-center text-xl font-medium text-primary">
              On échange préalablement par téléphone.<br />
              Je me déplace chez toi ou on fait le nettoyage en visio.
            </p>
            
            <p>
              Chaque lieu garde les empreintes de ce qui s'est vécu entre ses murs : émotions, mémoires, fatigues, colères, peurs…<br />
              Je me connecte à l'espace et à tous ses habitants — humains, animaux, plantes, objets — pour libérer, réaligner, harmoniser.
            </p>
            
            <p>
              Tu recevras aussi des outils simples et vibratoires pour entretenir ton espace en autonomie 
              (rituels, fréquences, cristaux, respiration, prière).
            </p>
            
            <div className="bg-primary/5 p-6 rounded-lg mt-8">
              <p className="text-xl font-medium text-center">
                ⏳ Durée : entre 1h et 2h<br />
                💸 Tarif : à partir de 180 €
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Réservation section */}
      <section className="bg-accent/10 p-8 rounded-lg reveal-on-scroll">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="section-title mb-4">Demander un nettoyage</h2>
          <p className="text-xl mb-8">
            Retrouve la paix et l'harmonie dans ton espace de vie
          </p>
          <Button size="lg" onClick={openCalendly}>
            Réserver ce soin
          </Button>
        </div>
      </section>
    </ServicePageLayout>
  );
};

export default NettoyageLieux;
